// 3. LISTE DES ANALYSES
// components/consultation/AnalysesList.tsx
import React from "react";
import { ClipboardList, Edit, Trash2, PlusCircle } from "lucide-react";
import type { Analyse } from "../../../types/analyse";

interface AnalysesListProps {
  analyses: Analyse[];
  onAdd: () => void;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
}

export const AnalysesList: React.FC<AnalysesListProps> = ({
  analyses,
  onAdd,
  onEdit,
  onDelete,
}) => {
  if (analyses.length === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h5 className="font-semibold text-blue-800 flex items-center">
          <ClipboardList className="mr-2" size={16} />
          Analyses demandées ({analyses.length})
        </h5>
        <button
          onClick={onAdd}
          className="text-sm px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center"
        >
          <PlusCircle className="mr-1" size={14} />
          Ajouter
        </button>
      </div>
      
      <div className="space-y-2">
        {analyses.map((analyse, index) => (
          <div
            key={analyse.id || index}
            className="bg-white rounded-lg p-3 border border-blue-100 flex justify-between items-start"
          >
            <div className="flex-1">
              <div className="font-medium text-blue-900">
                {analyse.label || analyse.nom}
              </div>
              {(analyse.reason || analyse.reason) && (
                <div className="text-sm text-blue-700 mt-1">
                  Raison: {analyse.reason || analyse.reason}
                </div>
              )}
              {analyse.diagnostics && (
                <div className="text-sm text-blue-600 mt-1">
                  Diagnostics: {analyse.diagnostics}
                </div>
              )}
              {analyse.conseils && (
                <div className="text-sm text-blue-600 mt-1">
                  Conseils: {analyse.conseils}
                </div>
              )}
            </div>
            <div className="flex gap-2 ml-3">
              <button
                onClick={() => onEdit(index)}
                className="p-1 text-blue-600 hover:bg-blue-100 rounded transition-colors"
                title="Modifier"
              >
                <Edit size={14} />
              </button>
              <button
                onClick={() => onDelete(index)}
                className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors"
                title="Supprimer"
              >
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalysesList;